import * as captchaTypes from '../types/Captcha';
import * as errorActions from './Error';
import * as apiCalls from '../api/ApiCalls';
import { API_URL } from '../api/ApiSettings';

export function getCaptchaSiteKey() {
    return async (dispatch) => {
        dispatch(getCaptchaSiteKeyRequest());
        try {
            dispatch(errorActions.clearError());
            const response = await apiCalls.GetCaptchaSiteKey();
            const result = await response.json();
            if(response.status===200) {
                return dispatch(getCaptchaSiteKeySuccess(result));
            }
            else{
                return dispatch(errorActions.throwNewError("Błąd pobierania danych",result.exceptionMessage));
            }
            
        } catch (error) {
            dispatch(errorActions.throwNewError("Błąd pobierania danych",error.message));
        }
    };
} 

export function getCaptchaSiteKeyRequest() {
    return {
        type: captchaTypes.GET_CAPTCHA_SITE_KEY_REQUEST
    };
}

export function getCaptchaSiteKeySuccess(captchaSiteKey) {
    return {
        type: captchaTypes.GET_CAPTCHA_SITE_KEY_SUCCESS,
        payload: captchaSiteKey
    };
}


export function validateCaptcha(captchaResponse) {
    return async (dispatch) => {
        dispatch(validateCaptchaRequest());
        try {
            dispatch(errorActions.clearError());
            const response = await apiCalls.ValidateCaptcha(captchaResponse);
            const result = await response.json();
            if(response.status===200) {
                return dispatch(validateCaptchaSuccess(result));
            }
            else{
                dispatch(errorActions.throwNewError("Błąd pobierania danych",result.exceptionMessage));
            }
            
        } catch (error) {
            dispatch(errorActions.throwNewError("Błąd pobierania danych",error.message));
        }
    };
} 


export function validateCaptchaFailure(error) {
    return {
        type: captchaTypes.VALIDATE_CAPTCHA_RESULT_FAILURE,
        payload: error
    };
}

export function validateCaptchaRequest() {
    return {
        type: captchaTypes.VALIDATE_CAPTCHA_RESULT_REQUEST
    };
}

export function validateCaptchaSuccess(validationResult) {
    return {
        type: captchaTypes.VALIDATE_CAPTCHA_RESULT_SUCCESS,
        payload: validationResult
    };
}


// WEBPACK FOOTER //
// ./src/actions/Captcha.js